import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useTheme } from "../context/ThemeContext";

const SVG = {
  dashboard: <svg className="w-4.5 h-4.5" style={{width:"18px",height:"18px"}} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" /></svg>,
  documents: <svg className="w-4.5 h-4.5" style={{width:"18px",height:"18px"}} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" /></svg>,
  upload: <svg className="w-4.5 h-4.5" style={{width:"18px",height:"18px"}} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" /></svg>,
  reports: <svg className="w-4.5 h-4.5" style={{width:"18px",height:"18px"}} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" /></svg>,
  calendar: <svg className="w-4.5 h-4.5" style={{width:"18px",height:"18px"}} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>,
  sars: <svg className="w-4.5 h-4.5" style={{width:"18px",height:"18px"}} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2z" /></svg>,
  calc: <svg className="w-4.5 h-4.5" style={{width:"18px",height:"18px"}} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" /></svg>,
  profile: <svg className="w-4.5 h-4.5" style={{width:"18px",height:"18px"}} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>,
  bell: <svg className="w-4.5 h-4.5" style={{width:"18px",height:"18px"}} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" /></svg>,
  settings: <svg className="w-4.5 h-4.5" style={{width:"18px",height:"18px"}} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg>,
  team: <svg className="w-4.5 h-4.5" style={{width:"18px",height:"18px"}} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" /></svg>,
  share: <svg className="w-4.5 h-4.5" style={{width:"18px",height:"18px"}} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" /></svg>,
  analytics: <svg className="w-4.5 h-4.5" style={{width:"18px",height:"18px"}} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>,
  budget: <svg className="w-4.5 h-4.5" style={{width:"18px",height:"18px"}} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" /></svg>,
  pricing: <svg className="w-4.5 h-4.5" style={{width:"18px",height:"18px"}} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>,
  credit: <svg className="w-4.5 h-4.5" style={{width:"18px",height:"18px"}} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" /></svg>,
  invest: <svg className="w-4.5 h-4.5" style={{width:"18px",height:"18px"}} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" /></svg>,
};

const NAV_SECTIONS = [
  {
    label: null,
    items: [
      { icon: SVG.dashboard, label: "Dashboard", path: "/dashboard", active: true },
      { icon: SVG.documents, label: "My Documents", path: "/documents", active: true },
      { icon: SVG.upload, label: "Upload Document", path: "/upload", active: true },
    ],
  },
  {
    label: "Tax Tools",
    items: [
      { icon: SVG.reports, label: "Tax Returns", path: "/tax-returns", active: true },
      { icon: SVG.calendar, label: "Tax Calendar", path: "/tax-calendar", active: true },
      { icon: SVG.sars, label: "SARS Submissions", path: "/sars", active: true },
      { icon: SVG.calc, label: "Tax Calculator", path: "/calculator", active: true },
    ],
  },
  {
    label: "Account",
    items: [
      { icon: SVG.profile, label: "My Profile", path: "/profile", active: true },
      { icon: SVG.bell, label: "Notifications", path: "/notifications", active: true },
      { icon: SVG.settings, label: "Settings", path: "/settings", active: true },
    ],
  },
  {
    label: "Finance",
    items: [
      { icon: SVG.budget, label: "Budget Planner", path: "/budget", active: true },
      { icon: SVG.credit, label: "Credit & Debt", path: "/credit-debt", active: true },
      { icon: SVG.invest, label: "Investments", path: "/investments", active: true },
      { icon: SVG.analytics, label: "Analytics", path: "/analytics", active: true },
      { icon: SVG.pricing, label: "Plans & Pricing", path: "/pricing", active: true },
    ],
  },
  {
    label: "Business",
    items: [
      { icon: SVG.team, label: "Team Access", path: null, soon: true },
      { icon: SVG.share, label: "Shared Documents", path: null, soon: true },
    ],
  },
];

export default function Sidebar({ mobileOpen, setMobileOpen }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();
  const { isDark, toggleTheme } = useTheme();

  const initials = (user?.full_name || user?.email || "U")
    .split(" ").map(n => n[0]).join("").toUpperCase().slice(0, 2);

  const handleNav = (item) => {
    if (!item.active) return;
    navigate(item.path);
    setMobileOpen && setMobileOpen(false);
  };

  const isActive = (path) => path && location.pathname === path;

  return (
    <>
      {/* Mobile overlay */}
      {mobileOpen && (
        <div
          className="fixed inset-0 z-20 bg-black/60 backdrop-blur-sm lg:hidden"
          onClick={() => setMobileOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside className={`
        fixed top-0 left-0 h-full z-30 flex flex-col
        w-64 transition-transform duration-300
        glass-sidebar
        ${mobileOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}
      `}>

        {/* Logo */}
        <div className="flex items-center gap-3 px-5 py-5 border-b border-white/[0.06]">
          <div className="w-9 h-9 glass-gold rounded-xl flex items-center justify-center flex-shrink-0">
            <svg className="w-5 h-5 text-luxury-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <div className="min-w-0">
            <p className="font-bold text-sm truncate text-luxury-text tracking-wide">
              TaxVault
            </p>
            <p className="text-xs truncate text-luxury-secondary">
              South Africa
            </p>
          </div>
          <button
            onClick={() => setMobileOpen && setMobileOpen(false)}
            className="ml-auto lg:hidden text-luxury-secondary hover:text-luxury-text"
          >
            ✕
          </button>
        </div>

        {/* Navigation */}
        <nav className="flex-1 overflow-y-auto py-4 px-3 space-y-0.5">
          {NAV_SECTIONS.map((section, si) => (
            <div key={si} className={si > 0 ? "pt-4" : ""}>
              {section.label && (
                <p className="text-xs font-semibold uppercase tracking-widest px-3 mb-2 text-luxury-muted">
                  {section.label}
                </p>
              )}
              {section.items.map((item) => {
                const active = isActive(item.path) && !item.soon;
                return (
                  <button
                    key={item.label}
                    onClick={() => handleNav(item)}
                    disabled={item.soon}
                    className={`
                      w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium
                      transition-all duration-150 group relative
                      ${item.soon
                        ? "text-luxury-muted cursor-not-allowed"
                        : active
                          ? "glass-gold text-luxury-text border-l-2 border-luxury-gold shadow-sm"
                          : "text-luxury-secondary hover:glass-thin hover:text-luxury-text"
                      }
                    `}
                  >
                    <span className={`flex-shrink-0 ${active ? "text-luxury-gold" : ""} ${item.soon ? "opacity-30" : ""}`}>
                      {item.icon}
                    </span>
                    <span className="flex-1 text-left truncate">{item.label}</span>
                    {item.soon && (
                      <span className="text-xs px-1.5 py-0.5 rounded-full font-medium flex-shrink-0 glass text-luxury-muted">
                        Soon
                      </span>
                    )}
                  </button>
                );
              })}
            </div>
          ))}
        </nav>

        {/* Bottom section */}
        <div className="border-t border-white/[0.06] px-3 py-3 space-y-1">

          {/* Dark mode toggle */}
          <button
            onClick={toggleTheme}
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-all text-luxury-secondary hover:text-luxury-text hover:glass-thin"
          >
            <span className="text-base">{isDark ? "☀️" : "🌙"}</span>
            <span className="flex-1 text-left">{isDark ? "Light Mode" : "Dark Mode"}</span>
            <div className={`w-9 h-5 rounded-full flex items-center px-0.5 transition-colors ${isDark ? "bg-luxury-gold" : "bg-luxury-muted"}`}>
              <div className={`w-4 h-4 bg-white rounded-full shadow transition-transform ${isDark ? "translate-x-4" : "translate-x-0"}`} />
            </div>
          </button>

          {/* User info + logout */}
          <div className="flex items-center gap-3 px-3 py-2.5 rounded-xl glass border-white/[0.07]">
            <div className="w-8 h-8 bg-luxury-bg border border-luxury-gold/50 rounded-full flex items-center justify-center flex-shrink-0">
              <span className="text-luxury-gold font-bold text-xs">{initials}</span>
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs font-semibold truncate text-luxury-text">
                {user?.full_name || "User"}
              </p>
              <p className="text-xs truncate text-luxury-secondary">
                {user?.email}
              </p>
            </div>
            <button
              onClick={logout}
              title="Logout"
              className="flex-shrink-0 p-1 rounded-lg transition-colors text-luxury-muted hover:text-red-400 hover:bg-red-900/20"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                  d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
              </svg>
            </button>
          </div>
        </div>
      </aside>
    </>
  );
}
